import { Divider, Paper, Text } from '@mantine/core';
import React from 'react';
import B2BInput from '../components/common/B2BInput';

const SalesOrderPayment = ({ financialBreakdown, grn, setGrn }) => {

  const handleChange = (event, key) => {
    const value = event.target.value;
    setGrn((prev) => ({
      ...prev,
      [key]: value
    }))
  }
  return (
    <div style={{ flex: '0 0 27%', minWidth: '100px', marginTop: '1rem' }}>
      <Paper withBorder p="md">
        <div style={{ display: 'grid', gap: '8px', height: '100%' }}>
          {financialBreakdown?.map((row, idx) =>
            row.divider ? (
              <Divider key={idx} />
            ) : (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: idx === 0 ? '0' : '1rem',
                  backgroundColor: row.highlight ? '#8BC53F' : '',
                  padding: '0.3rem 0.5rem',
                  borderRadius: '5px',
                }}
              >
                <Text
                  fw={row.highlight || row.netPayable ? 700 : 400}
                  style={{
                    fontSize: '15px',
                    color: row.highlight ? 'white' : '',
                  }}
                >
                  {row.label}
                </Text>
                <Text
                  fw={row.highlight || row.netPayable ? 700 : 400}
                  style={{
                    color: row.highlight ? 'white' : '',
                  }}
                >
                  {row.type !== 'TextField' ? (
                    row.value != null ? (
                      row.isCurrency === false ? (
                        row?.value
                      ) : (
                        `${row.points === true ? '' : '₹ '}${Number(row.value).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}${row.points === true ? ' PTS' : ''}`
                      )
                    ) : null
                  ) : (
                    <div key={row} className="mb-2">
                      <B2BInput
                        type="text"
                        name="netWeight"
                        value={grn?.netWeight || ''}
                        onChange={(e) => handleChange(e, 'netWeight')}
                        readOnly={row.readOnly}
                        className="border px-2 py-1 rounded w-full"
                        disabled={row?.disabled}
                      />
                    </div>
                  )}
                </Text>
              </div>

            )
          )}
        </div>
      </Paper>
    </div>
  );
};

export default SalesOrderPayment;

